module.exports = __webpack_public_path__ + "media/img/email/map_nav-abf64e2c64af9b3dec94ea347decd19a.png";